<template>
  <div class="reservat">
    <el-badge class="waiting-item">
      <el-tabs
        v-model="reservatStatus"
        type="border-card"
        @tab-click="changeStatus"
      >
        <el-tab-pane label="全部" name="全部"></el-tab-pane>
        <el-tab-pane label="报备" name="reservation"></el-tab-pane>
        <el-tab-pane label="带看" name="visit"></el-tab-pane>
        <el-tab-pane label="认购" name="recognition"></el-tab-pane>
        <el-tab-pane label="签约" name="netSign"></el-tab-pane>
      </el-tabs>
    </el-badge>
    <div class="main-filter">
      <div class="filter flex-between">
        <div>
          <el-input
            v-model="query.filter"
            class="search-name input-with-select"
            reserve-keyword
            clearable
            :placeholder="searchText"
            @clear="getReservationList"
            @keyup.enter.native="enterSearch"
          >
            <el-select
              v-model="searchText"
              slot="prepend"
              placeholder="全文搜索"
              @change="filterSelect"
            >
              <el-option label="客户姓名" value="请输入客户姓名"></el-option>
              <el-option
                label="客户手机号"
                value="请输入客户手机号"
              ></el-option>
              <el-option
                label="全文搜索"
                value="请输入客户姓名/客户手机号"
              ></el-option>
            </el-select>
          </el-input>
          <el-button
            type="primary"
            @click="getReservationList"
            class="filter-btn"
            >查询</el-button
          >
          <el-button type="text" class="delete-btn" @click="deleteFilter"
            ><i class="el-icon-delete el-icon--right"></i>清空全部</el-button
          >
        </div>
        <el-button
          type="primary"
          @click="exportReservation"
          :disabled="reservationList.length == 0"
          :loading="isLoadingDownload"
          >下载报表</el-button
        >
      </div>
      <div class="filter-select">
        <div class="filter-item">
          <span class="filter-tit">楼盘</span>
          <el-select
            v-model="query.estateName"
            @change="estateNameChange"
            filterable
            remote
            @visible-change="estateVisibleChange"
            :remote-method="getEstates"
            @clear="estates = []"
            placeholder="请输入楼盘名称/地址"
            clearable
            :no-data-text="noDataText"
          >
            <el-option
              v-for="item in estates"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-tit">经纪人</span>
          <el-select
            v-model="query.brokerName"
            placeholder="请输入经纪人姓名/电话"
            filterable
            remote
            clearable
            :remote-method="getUsersSearch"
            @visible-change="userVisibleChange"
            @change="getBroker"
            @clear="creatorlist = []"
            :no-data-text="noDataText"
          >
            <el-option
              v-for="item in creatorlist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-show="item.name"
            >
              <span style="float: left">{{ item.name }}</span>
              <span
                style="
                  float: right;
                  color: #8492a6;
                  font-size: 13px;
                  width: 100px;
                  text-align: right;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
                >{{ item.organizationUnit }}</span
              >
            </el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-tit">门店</span>
          <el-select
            v-model="query.organizationUnit"
            @change="getOrganizationUnit"
            filterable
            remote
            :remote-method="getOrgs"
            @visible-change="orgVisibleChange"
            @clear="clearOrg"
            placeholder="请输入门店名称/地址"
            clearable
            :no-data-text="noDataText"
          >
            <el-option
              v-for="item in orgList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-tit">渠道</span>
          <el-select
            v-model="query.channelName"
            placeholder="请输入渠道人员姓名/电话"
            filterable
            remote
            clearable
            :remote-method="getChannelSearch"
            @visible-change="channelVisibleChange"
            @change="getChannel"
            @clear="channellist = []"
            :no-data-text="noDataText"
          >
            <el-option
              v-for="item in channellist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-show="item.name"
            >
              <span style="float: left">{{ item.name }}</span>
              <span
                style="
                  float: right;
                  color: #8492a6;
                  font-size: 13px;
                  width: 100px;
                  text-align: right;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
                >{{ item.organizationUnit }}</span
              >
            </el-option>
          </el-select>
        </div>
        <div class="flex filter-item">
          <span class="filter-tit">{{ searchTimeText }}</span>
          <el-date-picker
            v-model="searchTime"
            type="daterange"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getReservationList"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </div>
      </div>
    </div>
    <el-table :data="reservationList" border>
      <el-table-column
        label="楼盘名称"
        :resizable="false"
        align="left"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span class="todetails" @click="toEstate(scope.row.estateId)">{{
            scope.row.estateName | nullValue
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户" :resizable="false" align="left">
        <template slot-scope="scope">
          <span class="todetails" @click="toCustomer(scope.row.customerId)">{{
            scope.row.customerName | nullValue
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="经纪人"
        :resizable="false"
        align="left"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.creatorName | nullValue
          }}<span v-if="scope.row.organizationUnit"
            >({{ scope.row.organizationUnit | nullValue }})</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="渠道"
        :resizable="false"
        align="left"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.channelName | nullValue
          }}<span v-if="scope.row.channelOrganizationUnit"
            >({{ scope.row.channelOrganizationUnit | nullValue }})</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="带看次数"
        :resizable="false"
        align="left"
        v-if="reservatStatus == 'visit'"
      >
        <template slot-scope="scope">
          {{ scope.row.visitNum == 0 ? "—" : scope.row.visitNum }}
        </template>
      </el-table-column>
      <el-table-column
        label="认购次数"
        :resizable="false"
        align="left"
        v-if="reservatStatus == 'recognition'"
      >
        <template slot-scope="scope">
          {{ scope.row.recognitionNum == 0 ? "—" : scope.row.recognitionNum }}
        </template>
      </el-table-column>
      <el-table-column
        label="签约次数"
        :resizable="false"
        align="left"
        v-if="reservatStatus == 'netSign'"
      >
        <template slot-scope="scope">
          {{ scope.row.netSignNum == 0 ? "—" : scope.row.netSignNum }}
        </template>
      </el-table-column>
      <el-table-column
        :label="searchTimeText"
        :resizable="false"
        align="left"
        min-width="100"
      >
        <template slot-scope="scope">
          <span
            v-if="
              reservatStatus == '全部' ||
              reservatStatus == 'waiting' ||
              reservatStatus == 'reservation'
            "
          >
            {{ scope.row.creationTime | nullValue }}
          </span>
          <span v-if="reservatStatus == 'visit'">
            {{ scope.row.lastVisitTime | nullValue }}
          </span>
          <span v-if="reservatStatus == 'recognition'">
            {{ scope.row.lastRecognitionTime | nullValue }}
          </span>
          <span v-if="reservatStatus == 'netSign'">
            {{ scope.row.lastNetSignTime | nullValue }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="状态" :resizable="false" align="left">
        <template slot-scope="scope">
          {{ scope.row.flowStatus | nullValue }}
          <span
            v-if="scope.row.reviewStatus"
            :class="
              scope.row.reviewStatus == '已通过'
                ? 'success'
                : scope.row.reviewStatus == '已驳回'
                ? 'error'
                : 'waiting'
            "
            >（{{ scope.row.reviewStatus }}）</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" :resizable="false" align="left">
        <template slot-scope="scope">
          <span class="theme-color" @click="goDetail(scope.row.id)">详情</span>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="loading-box" v-if="isLoading">
          <img
            src="@/assets/image/loading.png"
            alt="loading"
            class="loading-ico"
          />
          数据加载中...
        </div>
        <div class="empty-box" v-if="!isLoading && !reservationList.length">
          列表为空
        </div>
      </template>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageIndex"
      :page-sizes="[20, 30, 50, 100]"
      :page-size="query.maxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    ></el-pagination>
  </div>
</template>

<script>
import {
  getHistoryReservations,
  exportHistoryReservation,
} from "@/http/api/reservations";
import { getUsersSearch } from "@/http/api/employe";
import { getOrgsSearch } from "@/http/api/organization";
import { getEstates } from "@/http/api/estate";
export default {
  data() {
    return {
      pageIndex: 1,
      totalCount: 0,
      reservatStatus: "全部",
      searchText: "请输入客户姓名/客户手机号",
      searchTimeText: "报备日期",
      noDataText: "无数据",
      isLoading: false,
      isLoadingDownload: false,
      query: {
        filter: "",
        condition: "",
        estateName: "",
        channelName: "",
        brokerName: "",
        organizationUnit: "",
        brokerId: "",
        estateId: "",
        channelId: "",
        organizationUnitId: "",
        flowStatus: "",
        maxResultCount: 30,
        skipCount: 0,
        sorting: "creationTime desc",
        isForReport: true,
      },
      reservationList: [],
      searchTime: [],
      createDaterange: [],
      creatorlist: [],
      channellist: [],
      orgList: [],
      estates: [],
      estateName: "",
    };
  },
  mounted() {
    let obj = this.$route.params.obj;
    if (obj) {
      obj = JSON.parse(obj);
      console.log(obj, "obj");
      if (obj.flowStatus) {
        this.reservatStatus = obj.flowStatus;
        this.searchTime = [obj.startTime, obj.endTime];
        this.query.estateId = obj.estateId;
        this.query.estateName = obj.estateName;
        this.query.organizationUnitId = obj.organizationUnitId;
        this.query.organizationUnit = obj.organizationUnit;
        this.query.channelId = obj.channelId;
        this.query.channelName = obj.channelName;
        this.query.brokerId = obj.brokerId;
        this.query.brokerName = obj.brokerName;
        this.query.isForReport = true;
        switch (obj.flowStatus) {
          case "visit":
            this.searchTimeText = "带看日期";
            break;
          case "recognition":
            this.searchTimeText = "认购日期";
            break;
          case "netSign":
            this.searchTimeText = "签约日期";
            break;
          case "reservation":
            this.searchTimeText = "报备日期";
            break;
        }
      }
    }
    this.getReservationList();
  },
  methods: {
    exportReservation() {
      this.isLoadingDownload = true;
      let query = {
        skipCount: 0,
        isForReport: this.query.isForReport,
        sorting: this.query.sorting,
      };
      if (this.query.filter) {
        query.filter = this.query.filter;
      }
      if (this.query.condition) {
        query.condition = this.query.condition;
      }
      if (this.reservatStatus != "全部") {
        query.flowStatus = this.reservatStatus;
      }
      if (this.searchTime && this.searchTime.length) {
        query.startTime = this.searchTime[0];
        query.endTime = this.searchTime[1];
      }
      if (this.query.brokerId) {
        query.brokerId = this.query.brokerId;
      }
      if (this.query.estateId) {
        query.estateId = this.query.estateId;
      }
      if (this.query.channelId) {
        query.channelId = this.query.channelId;
      }
      if (this.query.organizationUnitId) {
        query.organizationUnitId = this.query.organizationUnitId;
      }
      exportHistoryReservation(query)
        .then((res) => {
          const content = res;
          const blob = new Blob([content]);
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = "历史报备列表.xlsx";
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, "历史报备列表.xlsx");
          }
          this.isLoadingDownload = false;
        })
        .catch((err) => {
          this.isLoadingDownload = false;
        });
    },
    deleteFilter() {
      this.query.brokerId = "";
      this.query.channelId = "";
      this.query.estateId = "";
      this.query.organizationUnitId = "";
      this.query.channelName = "";
      this.query.estateName = "";
      this.query.brokerName = "";
      this.query.flowStatus = "";
      this.query.reviewStatus = "";
      this.query.filter = "";
      this.query.condition = "";
      this.searchTime = [];
      this.createDaterange = [];

      this.getReservationList();
      this.query.excludeReviewStatus = false;
    },
    goDetail(id) {
      this.$router.push({ path: `/reservation/detail/${id}` });
    },
    getBroker(v) {
      this.query.brokerId = v;
      this.getReservationList();
    },
    getChannel(v) {
      this.query.channelId = v;
      this.getReservationList();
    },
    getOrganizationUnit(v) {
      this.query.organizationUnitId = v;
      this.getReservationList();
    },
    estateNameChange(v) {
      this.query.estateId = v;
      this.getReservationList();
    },
    estateVisibleChange(v) {
      if (!v) {
        this.estates = [];
      }
    },
    getEstates(v) {
      if (v) {
        let query = {
          filter: v,
          condition: "name",
          maxResultCount: 30,
        };
        this.noDataText = "加载中...";
        getEstates(query)
          .then((res) => {
            if (res && res.result) {
              this.estates = res.result.items;
            }
            this.noDataText = "无数据";
          })
          .catch(() => {
            this.noDataText = "无数据";
          });
      } else {
        this.estates = [];
      }
    },
    orgVisibleChange(v) {
      if (!v) {
        this.orgList = [];
      }
    },
    channelVisibleChange(v) {
      if (!v) {
        this.channellist = [];
      }
    },
    userVisibleChange(v) {
      if (!v) {
        this.creatorlist = [];
      }
    },
    getOrgsSearch(v) {
      this.orgList = [];
      let query = {
        filter: v,
        maxResultCount: 30,
      };
      this.noDataText = "加载中...";
      getOrgsSearch(query)
        .then((res) => {
          this.orgList = res.result.items;
          this.noDataText = "无数据";
        })
        .catch(() => {
          this.noDataText = "无数据";
        });
    },
    clearOrg() {
      this.orgList = [];
    },
    getOrgs(query) {
      if (query) {
        this.getOrgsSearch(query);
      } else {
        this.orgList = [];
      }
    },
    //获取经纪人
    getUsersSearch(e) {
      if (e) {
        var params = {
          filter: e,
          maxResultCount: 30,
        };
        let query = "";
        for (var key in params) {
          if (params[key] !== null && params[key] !== "") {
            query = `${key}=${params[key]}&${query}`;
          }
        }
        this.noDataText = "加载中...";
        getUsersSearch(query)
          .then((res) => {
            if (res.code == 10200) {
              this.creatorlist = res.result.items;
            }
            this.noDataText = "无数据";
          })
          .catch(() => {
            this.noDataText = "无数据";
          });
      } else {
        this.creatorlist = [];
      }
    },
    getChannelSearch(e) {
      if (e) {
        var params = {
          filter: e,
          maxResultCount: 30,
        };
        let query = "";
        for (var key in params) {
          if (params[key] !== null && params[key] !== "") {
            query = `${key}=${params[key]}&${query}`;
          }
        }
        this.noDataText = "加载中...";
        getUsersSearch(query)
          .then((res) => {
            if (res.code == 10200) {
              this.channellist = res.result.items;
            }
            this.noDataText = "无数据";
          })
          .catch(() => {
            this.noDataText = "无数据";
          });
      } else {
        this.channellist = [];
      }
    },
    enterSearch() {
      var evt = window.event || e;
      if (evt.keyCode == 13) {
        // 回车事件
        this.getReservationList();
      }
    },
    handleSizeChange(val) {
      this.query.maxResultCount = val;
      this.getReservationList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getReservationList();
    },
    toEstate(id) {
      this.$router.push({ path: `/estate/detail/${id}` });
    },
    toCustomer(id) {
      this.$router.push({ path: `/customer/detail/${id}` });
    },
    changeStatus(v) {
      this.pageIndex = 1;
      this.searchTime = [];
      Object.assign(this.$data.query, this.$options.data().query);
      let status = v.name;
      if (status == "全部" || status == "reservation") {
        this.searchTimeText = "报备日期";
      } else if (status == "visit") {
        this.searchTimeText = "带看日期";
      } else if (status == "recognition") {
        this.searchTimeText = "认购日期";
      } else if (status == "netSign") {
        this.searchTimeText = "签约日期";
      }
      this.getReservationList();
    },

    // 搜索前置条件
    filterSelect(val) {
      if (val == "请输入客户手机号") {
        this.query.condition = "creatorPhoneNumber";
      } else if (val == "请输入客户姓名") {
        this.query.condition = "customerName";
      } else {
        this.query.condition = "";
      }
    },
    getReservationList() {
      this.isLoading = true;
      this.reservationList = [];
      let query = {
        maxResultCount: this.query.maxResultCount,
        isForReport: this.query.isForReport,
        sorting: this.query.sorting,
        filter: this.query.filter,
        condition: this.query.condition,
      };
      if (this.reservatStatus != "全部") {
        query.flowStatus = this.reservatStatus;
      }
      if (this.searchTime && this.searchTime.length) {
        query.startTime = this.searchTime[0];
        query.endTime = this.searchTime[1];
      }
      if (this.query.brokerId) {
        query.brokerId = this.query.brokerId;
      }
      if (this.query.estateId) {
        query.estateId = this.query.estateId;
      }
      if (this.query.channelId) {
        query.channelId = this.query.channelId;
      }
      if (this.query.organizationUnitId) {
        query.organizationUnitId = this.query.organizationUnitId;
      }
      if (
        query.flowStatus == "visit" ||
        query.flowStatus == "recognition" ||
        query.flowStatus == "netSign"
      ) {
        query.sorting = "lastFlowTime desc";
      } else {
        query.sorting = "creationTime desc";
      }
      query.skipCount = (this.pageIndex - 1) * this.query.maxResultCount;
      getHistoryReservations(query)
        .then((res) => {
          this.reservationList = res.result.items;
          this.totalCount = res.result.totalCount;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
.reservat {
  ::v-deep .waiting-item {
    width: 100%;
    .el-tabs {
      width: 100%;
      .el-tabs__item {
        margin-right: 12px;
        border-radius: 4px 4px 0 0;
        padding: 0 30px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        border-bottom: 0;
        color: #333;
        background: #f7f7f7;
        &:hover {
          color: #fff;
          background: $--color-primary;
          opacity: 0.9;
        }
      }
      .is-active {
        border-bottom: 0;
        color: #fff;
        background: $--color-primary;
      }
      .el-tabs__nav-scroll {
        padding-left: 0;
        border-bottom: 2px solid $--color-primary;
      }
    }
    .el-badge__content {
      // top: -100px;
      z-index: 99;
      left: 49px;
      right: auto;
    }
  }
  .main-filter {
    .filter {
      @include flex(row, center);
      justify-content: space-between;
      margin-bottom: 20px;

      ::v-deep .input-with-select {
        margin-right: 20px;
        width: 440px;
        .el-input-group__prepend {
          width: 110px;
          .el-input__inner {
            width: 110px;
          }
        }
        .el-input__inner {
          width: 270px;
        }
      }
      .filter-type {
        width: 160px;
      }
      .filter-btn {
        margin-right: 10px;
      }
      .delete-btn {
        color: #717171;
      }
      .el-icon-delete {
        margin-right: 5px;
      }
    }
    .filter-select {
      @include flex(row, center);
      flex-wrap: wrap;
      margin-left: -20px;
      .filter-tit {
        margin: 0 20px;
        color: #717171;
      }

      .filter-item {
        margin-bottom: 20px;
      }
    }
  }
  ::v-deep .el-tabs {
    border: 0px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0), 0 0 6px 0 rgba(0, 0, 0, 0);

    .el-tabs__item {
      margin-right: 10px;
      border-bottom: 0;
      height: 30px;
      line-height: 30px;
      color: #717171;
      background: #f7f7f7;
      &:hover {
        color: #fff;
        background: $--color-primary;
        opacity: 0.9;
      }
    }
    .isactive {
      border-bottom: 0;
      color: #fff;
      background: $--color-primary;
    }
    .el-tabs__nav-scroll {
      padding-left: 0;
      border-bottom: 1px solid $--color-primary;
    }
    .el-tabs__header {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0), 0 0 6px 0 rgba(0, 0, 0, 0);
    }
  }
  .el-table {
    margin-bottom: 20px;
    .success {
      color: #74c55c;
    }
    .error {
      color: #999;
    }
    .waiting {
      color: #409eff;
    }
    .todetails {
      color: $--color-primary;
      cursor: pointer;
    }
  }
}
</style>
